import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const CollectorBrandSX: SxProps = {
	display: 'block',
	fontSize: '15px',
	fontWeight: OpenSansFontWeights.bold,
	color: 'grey.500',
};
